// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import loadGreifLocations from "@store/Framework/Store/Greif/Components/LocationFilters/Handlers/LoadGreifLocations";
import { LocationFilterModel } from "@store/Framework/Types/ApiModels";
import { useEffect } from "react";

/**
 * Cache-aware loader for the account's Greif Location list.
 *
 * Reads the shared cache at `state.greif.components.locationFilters` and dispatches `loadGreifLocations`
 * on mount; the handler chain dedupes against live store state, so all location consumers (Contact
 * Us form field, Order History and Shipment History filters) share one list fetched at most once
 * per session. Named `useGreifLocations` to avoid confusion with the router's `useLocation`.
 */
const useGreifLocations = (): { locations: LocationFilterModel[]; isLoading: boolean } => {
    const dispatch = useAppDispatch();
    const { locations, status } = useAppSelector(state => state.greif.components.locationFilters);

    useEffect(() => {
        dispatch(loadGreifLocations());
    }, []);

    return { locations, isLoading: status === "loading" };
};

export default useGreifLocations;
